import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
export default {
  email: [function (v) {
    return !!v || "O campo de e-mail é obrigatório!";
  }, function (email) {
    return validateEmail(email);
  }],
  whatsapp: [function (v) {
    return !!v || "O campo de WhatsApp é obrigatório!";
  }, function (whatsapp) {
    return validateWhatsApp(whatsapp);
  }]
};
var validateEmail = function validateEmail(email) {
  var emailValidatorRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  var isValid = String(email).toLowerCase().match(emailValidatorRegex);
  if (isValid) return true;
  return "O e-mail deve ser válido!";
};
var validateWhatsApp = function validateWhatsApp(whatsapp) {
  var whatsappValidatorRegex = /\(?([0-9]{2,3}|0{1}((x|[0-9]){2,3}[0-9]{2}))\)?\s*[0-9]{4,5}[- ]*[0-9]{4}/;
  var isValid = String(whatsapp).toLowerCase().match(whatsappValidatorRegex);
  if (isValid) return true;
  return "O número deve ser válido!";
};